/** Format raw bytes amount into human-readable format
 * @example formatBytes(1024) // 1 KB
 * @example formatBytes(1048576) // 1 MB
 */
export const formatBytes = (bytes: number) => {
    if (!bytes || bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(2))} ${sizes[i]}`;
};
